import { Link } from 'react-router-dom'
import { Shield } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface PoliciesEmptyProps {
  title?: string
  description?: string
  actionLabel?: string
  actionHref?: string
}

/**
 * PoliciesEmpty displays an empty state when no policies are found
 *
 * Features:
 * - Shield icon with dotted border
 * - Customizable heading and description
 * - CTA button linking to policy creation
 */
export function PoliciesEmpty({
  title = 'No policies found',
  description = 'Get started by creating your first access control policy using poli-x AI.',
  actionLabel = 'Create your first policy',
  actionHref = '/polix-ai',
}: PoliciesEmptyProps) {
  return (
    <div
      className="flex flex-col items-center justify-center py-16 px-4"
      data-testid="policies-empty"
    >
      <div className="flex h-20 w-20 items-center justify-center rounded-full border-2 border-dashed border-muted-foreground/40">
        <Shield className="h-10 w-10 text-muted-foreground/60" />
      </div>

      <h3 className="mt-6 text-lg font-semibold text-foreground">
        {title}
      </h3>

      <p className="mt-2 max-w-sm text-center text-sm text-muted-foreground">
        {description}
      </p>

      <Button asChild className="mt-6">
        <Link to={actionHref}>{actionLabel}</Link>
      </Button>
    </div>
  )
}
